/*
 * @ Author: wangjiyu
 * @Date: 2020-04-07 11:48:43
 * @LastEditTime: 2020-05-08 10:02:32
 * @LastEditors: wangjiyu
 * @Description: file content
 */
import { IPostBaseInfoState, IAction } from '../../interface';

import ActionType from '../../action/ActionType';

const baseInfoState = {
    cover: '',
    coverPixel: '',
    title: '',
    productId: '',
    topic: {},
    location: {},
    groupId:''
};
/* const baseInfoState = {
    cover:
        'http://t8.baidu.com/it/u=1484500186,1503043093&fm=79&app=86&f=JPEG?w=1280&h=853',
    coverPixel: '',
    title: '这是一个图文标题',
    productId: '',
    topic: {},
    location: {},
}; */

const baseInfo = (
    state: IPostBaseInfoState = baseInfoState,
    action: IAction
) => {
    switch (action.type) {
        case ActionType.PostSetTitle:
            return {
                ...state,
                title: action.payload.title,
            };
        case ActionType.PostSetProductId:
            return {
                ...state,
                productId: action.payload.productId,
            };
        case ActionType.PostSetTopic:
            return {
                ...state,
                topic: action.payload.topic,
            };
        case ActionType.PostSetLocation:
            return {
                ...state,
                location: action.payload.location,
            };
        case ActionType.PostSetCover:
            return {
                ...state,
                cover: action.payload.cover,
            };
        case ActionType.PostSetCoverPixel:
            return {
                ...state,
                coverPixel: action.payload.coverPixel,
            };
        case ActionType.PostGroupId:
            return {
                ...state,
                groupId: action.payload.groupId,
            };
        default:
            return state;
    }
};

export default baseInfo;
